import { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import type { ICategory } from "app/common/services/categoryService.types";
import { swSettings } from "app/common/services/swSettings";
import { proNavigator } from "single-spa/react-app/ProNavigator";

interface INavigationParams {
    category?: string;
    partnerListId?: string;
}

interface INavigationState {
    name: string;
}

const navigateToDefaultIndustryPage = (item: ICategory): void => {
    void proNavigator.go("digitalsuite_marketresearch_webmarketanalysis_mapping", {
        category: item.forUrl,
        country: "999",
        duration: BasicDurations.LAST_MONTH,
        webSource: devicesTypes.TOTAL,
    });
};

const navigateToCurrentPageWithNewCategory = (item: ICategory): void => {
    const currPageState = proNavigator.current();
    const currPageParams = proNavigator.getApiParams() as Record<string, unknown> | null;
    const currPageDefaultParams =
        swSettings.current?.defaultParams ?? swSettings.getCurrentComponent?.()?.defaultParams;

    const pageParams = currPageParams ?? currPageDefaultParams ?? {};

    void proNavigator.go(currPageState, {
        ...pageParams,
        category: item.forUrl,
    });
};

export const handleItemClick = (
    item: ICategory,
    _currentState: INavigationState,
    _currentParams: INavigationParams,
    isBlankHomePage: boolean,
): void => {
    if (isBlankHomePage) {
        navigateToDefaultIndustryPage(item);
    } else {
        navigateToCurrentPageWithNewCategory(item);
    }
};
